const changes = [
  {
    "type": "bugfix",
    "description": "Fix profile selector not showing the correct data after load.\n"
  }
];

export default changes;
